var _style, _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataResearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99 87.5",
    style: {
      enableBackground: "new 0 0 99 87.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#35B0CB;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#D2B859;}\n\t.st2{fill:none;stroke:#344154;stroke-width:3;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Data-Research") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_x2F_Data-Research"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M27.5-5c0-1.4-1.1-2.5-2.5-2.5S22.5-6.4,22.5-5s1.1,2.5,2.5,2.5S27.5-3.6,27.5-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "st0",
    points: "-7.5,62.5 2.5,62.5 2.5,29.5 -7.5,29.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    className: "st1",
    points: "76.5,62.5 86.5,62.5 86.5,12.5 76.5,12.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "st1",
    points: "20.5,62.5 30.5,62.5 30.5,11.5 20.5,11.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-9",
    className: "st2",
    d: "M32.5-5c0-4.1-3.4-7.5-7.5-7.5S17.5-9.1,17.5-5s3.4,7.5,7.5,7.5S32.5-0.9,32.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "st0",
    d: "M83.5-4c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5 C82.4-1.5,83.5-2.6,83.5-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-11",
    className: "st2",
    d: "M88.5-4c0-4.1-3.4-7.5-7.5-7.5S73.5-8.1,73.5-4s3.4,7.5,7.5,7.5S88.5,0.1,88.5-4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    className: "st0",
    points: "48.5,62.5 58.5,62.5 58.5,27.5 48.5,27.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-13",
    className: "st2",
    d: "M57.5,11c0-2.5-2-4.5-4.5-4.5s-4.5,2-4.5,4.5s2,4.5,4.5,4.5S57.5,13.5,57.5,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-14",
    className: "st2",
    d: "M1.5,13c0-2.5-2-4.5-4.5-4.5c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5C-0.5,17.5,1.5,15.5,1.5,13z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-15",
    className: "st2",
    x1: 0.5,
    y1: 9.5,
    x2: 18.5,
    y2: -1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-16",
    className: "st2",
    x1: 31.5,
    y1: -2.5,
    x2: 48.5,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-17",
    className: "st2",
    x1: 57.5,
    y1: 8.5,
    x2: 74.5,
    y2: -1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Stroke-3",
    className: "st2",
    x1: -7.5,
    y1: 72,
    x2: 86.5,
    y2: 72
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataResearchIcon);
export default __webpack_public_path__ + "static/media/Data-Research-Icon.adfbc6d6b9cb76dccb2a33f109865122.svg";
export { ForwardRef as ReactComponent };